import styles from './index.module.scss'
import cn from 'classnames'

export default function Field({ children, className, field }) {

    return (
        <div className={cn(className, styles.field)}>
            {children}
        </div>
    )

}